
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 384 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M161.949 394.702l-83.2-83.2c-4.998-4.998-4.998-13.103 0-18.102l18.102-18.102c4.998-4.999 13.103-4.999 18.102 0L171 331.345l120.048-120.047c4.998-4.998 13.103-4.998 18.102 0L327.25 229.4c4.998 4.999 4.998 13.103 0 18.102l-147.2 147.2c-4.999 4.999-13.104 4.999-18.102 0z","fill":"#00c527"}})])
          )
        }
      }
    